import { Themed } from "@client/styles/themes";
import React, { Fragment } from "react";

import { BlockGroup as Value } from "@reactivated";

import { StreamField } from "@thelabnyc/thelabui/src/components/StreamField";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { AccordionBlock } from "../AccordionBlock";
import { ArticleCardsBlock } from "../ArticleCardsBlock";
import { AuthorBlock } from "../AuthorBlock";
import { ComparisonCardsBlock } from "../ComparisonCardsBlock";
import { FeaturedReviewsBlock } from "../FeaturedReviewsBlock";
import { IconGridBlock } from "../IconGridBlock";
import { MediaCardsBlock } from "../MediaCardsBlock";
import { QuoteBlock } from "../QuoteBlock";
import { FeaturedRichTextBlock, RichTextBlock } from "../RichText";
import { SectionHeaderBlock } from "../SectionHeaderBlock";
import { ShowcaseBlock } from "../ShowcaseBlock";
import { SpacerBlock } from "../SpacerBlock";
import { SplitBlock } from "../SplitBlock";
import { StaggeredSplitBlock } from "../StaggeredSplitBlock";
import { TestimonialCardsBlock } from "../TestimonialCardsBlock";

import styles from "./index.module.scss";

export const BlockGroup = ({ value }: { value: Value }) => {
    if (!value.items) return <></>;

    return (
        <Themed theme={value.theme}>
            <section className={styles.root}>
                <div
                    className={concatClassNames([
                        styles.inner,
                        styles[value.container_width ?? "width12"],
                    ])}
                >
                    <StreamField
                        tagName={Fragment}
                        components={{
                            accordion: AccordionBlock,
                            author: AuthorBlock,
                            comparison_cards: ComparisonCardsBlock,
                            featured_reviews: FeaturedReviewsBlock,
                            featured_rich_text: FeaturedRichTextBlock,
                            icon_grid: IconGridBlock,
                            media_cards: MediaCardsBlock,
                            article_cards: ArticleCardsBlock,
                            quote: QuoteBlock,
                            rich_text: RichTextBlock,
                            section_header: SectionHeaderBlock,
                            showcase: ShowcaseBlock,
                            spacer: SpacerBlock,
                            split: SplitBlock,
                            staggered_split: StaggeredSplitBlock,
                            testimonials: TestimonialCardsBlock,
                        }}
                        value={value.items}
                    />
                </div>
            </section>
        </Themed>
    );
};
